<template>
  <v-expand-transition>
    <v-card v-if="selectedUser" flat>      

      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <v-row>
          <v-col cols="12">
            <v-checkbox
              class="mt-n4"
              label="Kan logga in med BankID och mobilt BankID."
              v-model="selectedUser.loginByBankId"
              :disabled="!(currentUser.userrole.isAdmin)"
          />
          </v-col>
          <v-col cols="12">
            <v-checkbox
              class="mt-n9"
              label="Kan logga in med användarnamn och lösenord."
              v-model="selectedUser.loginByEmail"
              :disabled="!(currentUser.userrole.isAdmin)"
            />
          </v-col>
        </v-row>
        <v-card-actions class="justify-space-between no-margins mt-6">
          <v-btn class="icon" @click="$emit('saveuser', selectedUser)" :disabled="!(currentUser.userrole.isAdmin)">
            <v-icon>$sl-check</v-icon>Spara
          </v-btn>
          <v-btn
            v-if="selectedUser.loginByEmail && selectedUser.id"
            class="icon" 
            @click="dialog=true" 
            :disabled="!(currentUser.userrole.isAdmin || currentUser.id == selectedUser.id)">
            <v-icon>$sl-locked</v-icon>Byt lösenord
          </v-btn>
        </v-card-actions>
      </v-form>
      <v-dialog v-model="dialog" max-width="600px">
        <ChangePassword v-if="dialog" @save="changePassword" @cancel="dialog=false" />
      </v-dialog>
    </v-card>
  </v-expand-transition>
</template>

<script>
import ChangePassword from '@/components/user/ChangePassword.vue'
import API from '@/services/api.js'
import {mapGetters, mapActions} from 'vuex'
import {RulesMixin} from '@/components/mixins'
export default {
  data() {
    return {
      valid: true,
      lazy: false,
      dialog: false,
      password: '',
      passwordConfirmation: ''
    }
  },

  components: {
    ChangePassword
  },

  computed: {
    ...mapGetters('user', ['selectedUser']),
    ...mapGetters('currentuser', ['currentUser'])
  },

  methods: {
    // @vuese
    // Changes the user password emitted from ChangePassword component
    // @arg The argument is a string with the new password
    changePassword(newPassword) {
      this.dialog = false

      //- Update or Create
      API.setUserPassword({
        data: {id: this.selectedUser.id, password: newPassword}
      })
      .then(response => {
        this.$events.fire('showInfo', 'Lösenordet ändrades')
      })
      .catch(error => {
        this.$events.fire('showError', 'Lösenordet kunde inte ändras')
        console.log('There was an error:', error)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>